import { useState, useCallback, useEffect, useContext } from "react";
import { PROJECTS_QUERY } from "../../pages/Private/Project/queries";
import { useApolloClient } from "react-apollo";
import { AuthContext } from "../../context/AuthProvider";

const useProjects = ({
  query = PROJECTS_QUERY,
  fetchPolicy = "network-only",
  syncToUser = true
} = {}) => {
  const [projects, setProjects] = useState([]);
  const [projectLists, setProjectLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const client = useApolloClient();
  const { user, setUser } = useContext(AuthContext);

  const fetchProjects = useCallback(
    async (opts = {}) => {
      try {
        const res = await client.query({
          query,
          variables: { id: user.id },
          // allow callers to force a fresh fetch
          fetchPolicy: opts.fetchPolicy ?? fetchPolicy
        });
        if (res) {
          const userProjects = [...res.data.userProjects];
          const sorted = res.data.userProjects.sort(a => {
            if (a.team) return 1;
            if (!a.team) return -1;
            return 0;
          });
          const subscriptionSorter = userProjects.sort(a => {
            if (a.downloadAccess || a.subscription) return -1;
            if (!a.downloadAccess || !a.subscription) return 1;
            return 0;
          });
          setProjects(sorted);
          setProjectLists(subscriptionSorter);

          if (syncToUser) setUser({ ...user, projects: res.data.userProjects });
          setLoading(false);
        }
      } catch (err) {
        console.log("projects ", err);
        // clear loading so consumers don't get stuck on skeletons forever
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [client, user.id, query, fetchPolicy, syncToUser]
  );

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return { loading, projects, projectLists, fetchProjects, setLoading };
};

export default useProjects;
